function zeroPaddedNumber(n, length) {
  let s = n.toString();
  while (s.length < length) {
    s = '0' + s
  }
  return s
}
export default zeroPaddedNumber;
